module.exports = __webpack_public_path__ + "img/logo_line.878cbe9d.png";